import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as stakeholder from '../stakeholder'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: stakeholder.RESOURCE.payload.dimension.partialId,
      partialId: stakeholder.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The type of training or learning support this stakeholder is likely to need.',
    isOptional: true,
    name: 'Training Audience / Need',
    partialId: PartialId.Standard.create('training_audience_need'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.stakeholderTrainingAudience.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
